import "./OpenedRequest.css";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../../index";
import { ref, get, update, remove, onValue } from "firebase/database";
import { useUserRole } from "../../components/Context/useUserRole";
import InputMask from 'react-input-mask';

export function UpdateOpenRequest() {
const { openRequestID } = useParams();
const [request, setRequest] = useState({});
const [loading, setLoading] = useState(true);
const navigate = useNavigate();
const [formValues, setFormValues] = useState({
    nameObject: "",
    address: "",
    engineer: "",
    contactPersonName: "",
    contactPersonPhone: "",
    description: "",
    date: "",
    createdDate: "",
});
const role = useUserRole();

const [engineers, setEngineers] = useState([]);

    const fetchEngineers = () => {
      const usersRef = ref(db, "users");
      onValue(usersRef, (snapshot) => {
        const usersData = snapshot.val();
        const engineersList = Object.values(usersData).filter((user) => user.role === "Инженер");
        setEngineers(engineersList);
      });
    };
  
    useEffect(() => {
      fetchEngineers();
    }, []);


useEffect(() => {
    const requestRef = ref(db, `request/${openRequestID}`);
    get(requestRef).then((snapshot) => {
        if (snapshot.exists()) {
            const requestValues = snapshot.val();
            setRequest(requestValues);
            setFormValues({
                ...requestValues,
            });
            setLoading(false);
        } else {
            console.error(`Заявка с ID ${openRequestID} не найдена`);
        }
    });
}, [openRequestID]);

const phoneRegex = /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/;

const handleFormChange = ({ target: { name, value } }) => {
    if (name === "date") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (new Date(value) >= today) {
        try {
            setFormValues((prevFormValues) => ({...prevFormValues, [name]: value }));
        } catch (error) {
            console.error("Ошибка обновления данных:", error);
            alert("Ошибка обновления данных. Пожалуйста попробуйте снова");
        }
        } else {
            alert("Дата не может быть раньше сегодняшней");
            return;
        }
    } else if (name === "contactPersonPhone") {
        if (!phoneRegex.test(value)) {
            alert("Пожалуйста, введите полный номер телефона");
            return;
        }
    }
    setFormValues((prevFormValues) => ({...prevFormValues, [name]: value }));
};

const updateRequest = async () => {
    const requestRef = ref(db, `request/${openRequestID}`);
    await update(requestRef, formValues);
    console.log(`Заявка с ID ${openRequestID} успешно обновлена`);
    navigate("/openedRequest");
};

const deleteRequest = async () => {
    const requestRef = ref(db, `request/${openRequestID}`);
    await remove(requestRef);
    console.log(`Request with ID ${openRequestID} deleted successfully`);
    navigate("/openedRequest");
};

const closeRequest = async () => {
    const requestRef = ref(db, `request/${openRequestID}`);
    await update(requestRef, { idRequest: true });
    console.log(`Request with ID ${openRequestID} closed successfully`);
    navigate("/openedRequest");
};

if (loading) {
    return <div>Загрузка...</div>;
}

    return (
        <div className="center">
            <div class="aside-right__desc">
                <form className="modal" onSubmit={(event) => event.preventDefault()}>
                    <h2>Управление заявкой</h2>
                    <div className="modal__item">
                        <label>
                            Объект
                            <input
                                type="text"
                                name="nameObject"
                                value={formValues.nameObject}
                                onChange={handleFormChange}
                                placeholder="Название объекта"
                            />
                        </label>
                    </div>
                    <div className="modal__item">
                        <label>
                            Адрес
                            <input
                                type="text"
                                name="address"
                                value={formValues.address}
                                onChange={handleFormChange}
                                placeholder="Адрес"
                            />
                        </label>
                    </div>
                    <div class="modal__item">
                        <label>
                            Создана:
                            <input 
                                className="inputDate readOnly"
                                type="date"
                                name="createdDate"
                                value={formValues.createdDate}
                                onChange={handleFormChange}
                                placeholder="Введите email"
                                readOnly
                            />
                        </label>
                    </div>
                    <div className="modal__item">
                        <label>
                            Контактное лицо на объекте
                            <div className="contactPerson">
                                <input
                                    type="text"
                                    name="contactPersonName"
                                    value={formValues.contactPersonName}
                                    onChange={handleFormChange}
                                    placeholder="Имя"
                                />
                                <InputMask
                                    type="tel"
                                    name="contactPersonPhone"
                                    value={formValues.contactPersonPhone}
                                    onChange={handleFormChange}
                                    mask="+7(999) 999-99-99"
                                    placeholder="Телефон"
                                />
                            </div>
                        </label>
                    </div>
                    <div className="modal__item">
                        <label htmlFor="engineer">Инженер
                            <select className="field-input block" name="engineer" value={formValues.engineer} onChange={handleFormChange}>
                                {engineers.map((engineer) => (
                                    <option key={engineer.userID} value={engineer.displayName}>
                                    {engineer.displayName}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                    <div className="modal__item">
                        <label>
                            Дата ремонта
                            <input
                                className="inputDate"
                                type="date"
                                name="date"
                                value={formValues.date}
                                onChange={handleFormChange}
                                placeholder="Дата ремонта"
                            />
                        </label>
                    </div>
                    <div className="modal__item modal__textarea">
                        <label>
                            Описание проблемы
                            <textarea
                                type="text"
                                name="description"
                                value={formValues.description}
                                onChange={handleFormChange}
                                placeholder="Опишите проблему"
                                formcontrolname="description"
                                maxLength="400"
                            />
                        </label>
                    </div>
                    <div className="modal__actions  modal__actions_btns">
                        {role === "Инженер" && (
                        <>
                            <button className="modal__button btn-item_close" onClick={closeRequest}>
                                Завершить
                            </button>
                        </>
                        )}
                        {role === "Директор" && (
                        <>
                            <button className="modal__button btn-item_close" onClick={closeRequest}>
                                Завершить
                            </button>
                            <button className="modal__button btn-item" onClick={updateRequest}>
                                Обновить
                            </button>
                            <button className="modal__button btn-item_delete" onClick={deleteRequest}>
                                Удалить
                            </button>
                        </>
                        )}
                        {role === "Диспетчер" && (
                        <>
                            <button className="modal__button btn-item_close" onClick={closeRequest}>
                                Завершить
                            </button>
                            <button className="modal__button btn-item" onClick={updateRequest}>
                                Обновить
                            </button>
                            <button className="modal__button btn-item_delete" onClick={deleteRequest}>
                                Удалить
                            </button>
                        </>
                        )}
                    </div>
                </form>
            </div> 
        </div>
    );
}